import { useEffect } from 'react';
import LoadingIndicator from '../../components/loadingIndicator';
import { useAppDispatch, useAppSelector } from '../../store';
import { startAppointmentFirstProcess, startPatientSearchProcess } from '../../actions/rd2RefactorActions';

const StartAppointmentFirstRedirector = () => {
	const dispatch = useAppDispatch();
	const enableAppointmentFirstScheduling = useAppSelector(
		(state: any) => state.config.availabilitySearch.enableAppointmentFirstScheduling,
	);
	const isInstanceLoaded = useAppSelector((state: any) => state.config.instance.isLoaded);
	const routePrefix = useAppSelector((state: any) => state.config.instance.routePrefix);

	useEffect(() => {
		// Wait for the product instance config, otherwise the setting reads false while loading.
		if (!isInstanceLoaded) {
			return;
		}

		// The only way into appointment-first mode. With the setting off this route falls back to
		// patient search, so the setting is a complete kill switch even for a typed-in URL.
		if (!enableAppointmentFirstScheduling) {
			dispatch(startPatientSearchProcess(routePrefix));
			return;
		}

		dispatch(startAppointmentFirstProcess(routePrefix));
	}, [isInstanceLoaded]);

	return <LoadingIndicator loadingMessage="Starting availability search..." />;
};

export default StartAppointmentFirstRedirector;
